<br>
<div>
    <div class="textBlock">
        <div>
            <p class="h2 text-center">Halte 3</p>
            <hr>
        </div>
        <div>
            <div class="text-center">
                <p class="h4 text-center">
                    Navigatie
                </p>
                <hr>
                <p class="text-center d-block margin">
                    Verlaat de parking via het weggetje bij de sporthal. Steek aan het verkeerslicht de Kopstraat over en wandel aan de overkant van de straat naar rechts. Sla vervolgens linksaf de Bloemendaallaan in. Kruis dan de Paalstraat en vervolg de Bloemendaallaan tot aan het eerste toegangsweggetje tot de wijk Bloemendaal.              
                </p>
                <hr>
                <p class="h4 text-center">
                    Historie
                </p>
                <hr>
                <p class="text-center d-block margin">
                    Dit stukje Bloemendaal was vroeger ‘de plak’: een groot en avontuurlijk speelbos met in het midden een grote vlakte met heuveltjes en paadjes. Je kon er zalig crossen met fiets, verstoppertje spelen, kampen bouwen, …              
                </p>
                <p class="text-center d-block margin">
                    Wist je dat de chiro eigenlijk hier, op deze plek begon? De eerste chirobijeenkomst – in 1950 – was op ‘de plak’. Ze duurde maar kort. Een uurtje. Want toen begon het plots vreselijk te regenen. En een lokaal was er nog niet. Maar de aftrap van de chiro was gegeven. En het is nooit meer gestopt. De chiro kreeg van de parochie een eigen plekje en lokalen, op de plaats waar ze nu nog altijd staan.             
                </p>
                <p class="text-center d-block margin">
                    Tot begin jaren ’90 liepen er elke zondag wel chirokinderen te spelen op ‘de plak’. Of kattekwaad uit te halen. Want het was een plek waar grote mensen niet kwamen. Wat is het ondeugendste dat jij ooit hebt gedaan in de chiro?                 
                </p>
            </div>
            <hr class="afterImage">
            <p class="h4 text-center">
                Navigatie
            </p>
            <hr>
            <p class="text-center d-block margin">
                Wandel intussen de Korenbloemlaan in en sla linksaf naar de Zonnedauwlaan. Ga daar op het einde naar rechts en steek door naar het speeltuintje.             
            </p>
        </div>
    </div>
    <div class="text-center buttonMargin">
        <button type="button" class="btn btn-primary" [routerLink]="'/halte4'">Volgende stop</button>
    </div>
</div>